import { merge } from '../../modules/sceneGraph';
import decompose from './decompose';

export default function setMatrixOnNode(store, nodeId, matrix4) {
  store.dispatch(merge([nodeId, 'Transform', 0], decompose(matrix4)));
}



// WEBPACK FOOTER //
// ./src/translators/utils/setMatrixOnNode.js